import { useState, useEffect } from "react";
import { SearchLogs } from "./components/SearchLogs";
import { ModalDetail } from "./components/ModalDetail";

type ID = undefined | null | number;

function ActivityLogs() {
    const [Records, setrecorsB] = useState<any>();
    const [ID, setID] = useState<ID>(undefined);
    const [info, setinfo] = useState<any>();
    const [typechante, setChangetype] = useState<any>();
    const [Bodypag, setBodypag] = useState<any>();

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const rowsPerPageOptions = [5, 10, 20, 50];
    const [totalRecords, setTotalRecords] = useState(0);

    const totalPages = Math.ceil(totalRecords / rowsPerPage);

    const handleFirstPage = () => setCurrentPage(1);
    const handlePreviousPage = () => setCurrentPage((p) => Math.max(1, p - 1));
    const handleNextPage = () => setCurrentPage((p) => Math.min(totalPages, p + 1));
    const handleLastPage = () => setCurrentPage(totalPages);

    const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(1);
    };

    // Removed startIndex and endIndex calculations

    function formatDate(dateString: string): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds = date.getUTCSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    }
    useEffect(() => {
        if (totalRecords < 5) {
            setCurrentPage(1);
        }
    }, [totalRecords]);

    return (
        <>
            <div className="card">
                <h1 className=' text-center f-titulo text-marino fs-md mt-10 '>Activity Logs</h1>

                <div className="card-body py3">
                    <SearchLogs
                        setrecorsB={setrecorsB}
                        setBodypag={setBodypag}
                        setTotalRecords={setTotalRecords}
                        currentPage={currentPage}
                        recordsPerPage={rowsPerPage}
                        setCurrentPage={setCurrentPage}
                    />
                    <div className='table-responsive'>
                        <table className='w-full f-parrafo  caption-bottom  custom-table' id='tablelogs'>
                            <thead>
                                <tr className="text-azul text-left">
                                    <th className="table-cell min-w-100px">Time (UTC)</th>
                                    <th className="table-cell min-w-100px">Username </th>
                                    <th className="table-cell min-w-100px">Email</th>
                                    <th className="table-cell min-w-100px">Action</th>
                                    <th className="table-cell min-w-100px">Target</th>
                                    <th className="table-cell min-w-100px">Details</th>
                                </tr>
                            </thead>
                            <tbody>
    {Records === undefined || Records.data?.length === 0 ? (
        <tr>
            <td colSpan={6} className="px-4 py-2 text-center text-sm text-semantic-text-primary border-b">
                {Records === undefined ? "Loading data..." : "No Data Available"}
            </td>
        </tr>
    ) : (
        Records.data.map((d: any, i: any) => (
            <tr key={i} className='table-row'>
                <td className="table-cell">{formatDate(d.createdAt)}</td>
                <td className="table-cell">{d.User !== null && d.User.firstName} {d.User !== null && d.User.lastName} {d.User === null && 'No data'}</td>
                <td className="table-cell">{d.User !== null && d.User.email} {d.User === null && 'No data'}</td>
                <td className="table-cell">{d.typeChange === 1 ? <span className="badge badge-light-success ">Create</span> : d.typeChange === 2 ? <span className="badge badge-light-azul">Update</span> : d.typeChange === 3 ? <span className="bagde badge-light-danger">Delete</span> : '---'}</td>
                <td className="table-cell"><span className="badge badge-secondary">{d.targetLog.name}</span></td>
                <td className="table-cell">
                    <button className=" btn-light-marino" onClick={() => (setID(d.id), setinfo(d.change), setChangetype(d.typeChange))}>See details</button>
                </td>
            </tr>
        ))
    )}
</tbody>
<tfoot>
    <tr>
        <td colSpan={6} className="pagination-footer">
            <div className="pagination-container">
            <span className="pagination-total">
                Total : {totalRecords}
            </span>
            <div className="pagination-controls-container">
            <div className="pagination-controls">
                <button
                    className="pagination-button"
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>
                <button
                    className="pagination-button"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                >
                    &lsaquo;
                </button>
                <span className="pagination-info">
                    {currentPage} of {totalPages || 1}
                </span>
                <button
                    className="pagination-button"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages || totalPages === 0}
                >
                    &rsaquo;
                </button>
                <button
                    className="pagination-button"
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages || totalPages === 0}
                >
                    &raquo;
                </button>
            </div>

            <div className="rows-per-page-container">
                <select
                    className="rows-per-page-select"
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                >
                    {rowsPerPageOptions.map((opt) => (
                        <option key={opt} value={opt}>
                            {opt}
                        </option>
                    ))}
                </select>
                <span className="rows-per-page-text">Rows per page</span>
            </div>

            </div>
            

            </div>
            
        </td>
    </tr>
</tfoot>
                        </table>
                    </div>
                    <br />
                </div>
            </div>
            {ID !== undefined && <ModalDetail setID={setID} id={ID} Info={info} typeChange={typechante} />}
        </>
    );
}

export { ActivityLogs };